module.exports = __webpack_public_path__ + "assets/bb67a04ac1fc97980a769029212b183a.svg";